import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export default function WalkthroughLayout({ children }: Props) {
  return (
    <div className="fixed inset-0 flex items-center justify-center" style={{ zIndex: 9999 }}>
      {/* グラデーション背景 */}
      <div className="absolute inset-0" style={{ backgroundColor: '#E7E7E7' }}>
        <div className="absolute inset-0 overflow-hidden">
          <div
            className="absolute rounded-full"
            style={{
              background: '#EEE6F6',
              width: '796.91px',
              height: '630.18px',
              right: '-100px',
              top: '-100px',
              filter: 'blur(200px)',
            }}
          />
          <div
            className="absolute rounded-full"
            style={{
              background: '#C6E2F4',
              width: '796.91px',
              height: '630.18px',
              left: '-100px',
              bottom: '-100px',
              filter: 'blur(200px)',
            }}
          />
        </div>
      </div>

      {/* 中央白カード */}
      <div
        className="relative z-10 flex flex-col items-center overflow-y-auto bg-white"
        style={{
          maxWidth: '1136px',
          width: '90vw',
          height: '728px',
          maxHeight: '90vh',
          borderRadius: '26px',
          boxShadow: '0px 0px 24px 0px rgba(0, 0, 0, 0.2)',
        }}
      >
        {children}
      </div>
    </div>
  );
}
